import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { GlobalService } from 'src/app/global.service';


@Component({
  selector: 'app-zone-wise-report-gst',
  templateUrl: './zone-wise-report-gst.component.html',
  styleUrls: ['./zone-wise-report-gst.component.scss']
})
export class ZoneWiseReportGstComponent implements OnInit {
    business_types = [];
    from_date: any = null;
    to_date: any = null;
    is_document_available: boolean = true;
    document_file: any = null;
    file_name: any = null;
    color: ThemePalette = 'primary';
    mode: ProgressSpinnerMode = 'indeterminate';
    title = null;
    selected_business_type_ids = [];
  constructor(private httpService: HttpService, private global: GlobalService) { 
    this.title = this.global._active_display_name;
    this.httpService.getBoothTypes().subscribe((data: []) => {
      console.log(data);
      this.business_types = data;
    }, (error) => {
      console.error(error);
    });
  }
  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'selected_business_type_id': this.selected_business_type_ids
    }
    console.log(data_dict)
    this.is_document_available = false;
    this.httpService.serveZoneWiseReport(data_dict).subscribe((data) => {
      console.log(data);
      this.is_document_available = true;
      if (data['is_data_available']) {
        this.document_file = data['excel'];
        this.file_name = data['file_name'];
      } else {
        alert('No data available');
        this.document_file = null;
        this.file_name = null;
      }
    }, (error) => {
      this.is_document_available = true;
      console.error(error);
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/octet-stream;base64,' + this.document_file;
    const downloadLink = document.createElement("a");
    const fileName = this.file_name;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  ngOnInit() {
  }

}
